import { CogOffIcon } from './CogOffIcon';

/**
 * author: Simran
 * id 7251B1CF-41C8-46F7-991D-83F5996CF0C1
 * name cog-off
 * version: 5.1.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cog-off.svg
 * tags
 * - Settings 
 */
export const SettingsOffIcon = CogOffIcon;
export default SettingsOffIcon